import styled, { css } from 'styled-components';

export const Container = styled.div`
  position: relative;
  width: ${(props) => props.$width || '300px'};
  user-select: none;
`;

export const SelectInput = styled.div.attrs({ role: 'combobox', tabIndex: 0 })`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  border: 1px solid ${(props) => (props.$isOpen ? '#007bff' : '#ccc')};
  border-radius: 6px;
  background-color: #fff;
  cursor: pointer;
  box-sizing: border-box;
  transition: all 0.2s ease-in-out;
  box-shadow: ${(props) => (props.$isOpen ? '0 0 0 2px rgba(0, 123, 255, 0.25)' : 'none')};

  &:focus-visible {
    outline: 2px solid #007bff;
    outline-offset: 1px;
  }
  ${(props) =>
    props.theme.theme === 'dark' &&
    css`
      background-color: #4f5761;
      border-color: ${(props) => (props.$isOpen ? '#007bff' : '#767676')};
    `}
`;

export const SelectText = styled.span`
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 8px;
  color: ${(props) => (props.$isPlaceholder ? '#999' : '#333')};
  font-size: 14px;
  ${(props) =>
    props.theme.theme === 'dark' &&
    css`
      color: #fff;
    `}
`;

export const Arrow = styled.span`
  border: solid #666;
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 3px;
  transform: ${(props) => (props.$isOpen ? 'rotate(-135deg)' : 'rotate(45deg)')};
  transition: transform 0.2s ease-in-out;
  ${(props) =>
    props.theme.theme === 'dark' &&
    css`
      border-color: #fff;
    `}
`;

export const Dropdown = styled.div.attrs({ role: 'listbox' })`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background-color: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  max-height: 240px;
  overflow-y: auto;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  z-index: 1000;
  ${(props) =>
    props.theme.theme === 'dark' &&
    css`
      background-color: #4f5761;
      border-color: #767676;
    `}
`;

export const OptionLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 5px 12px;
  cursor: pointer;
  transition: background-color 0.15s ease;

  &:hover {
    background-color: #f8f9fa;
    ${(props) =>
      props.theme.theme === 'dark' &&
      css`
        background-color: #767676;
      `}
  }
`;

export const Checkbox = styled.input.attrs({ type: 'checkbox' })`
  cursor: pointer;
  width: 16px !important;
  height: 16px !important;
  accent-color: #007bff;
`;

export const LabelText = styled.span`
  font-size: 14px;
  color: #333;
  ${(props) =>
    props.theme.theme === 'dark' &&
    css`
      color: #eee;
    `}
`;
